export { ScrollView as ScrollViewWithHeaderTitleSM } from 'react-native';
